var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 3.50018 0 2.25027 0.63661 1.37405C0.842209 1.09107 1.09107 0.842209 1.37405 0.63661C2.25027 0 3.50018 0 6 0C8.49982 0 9.74973 0 10.626 0.63661C10.9089 0.842209 11.1578 1.09107 11.3634 1.37405C12 2.25027 12 3.50018 12 6C12 8.49982 12 9.74973 11.3634 10.626C11.1578 10.9089 10.9089 11.1578 10.626 11.3634C9.74973 12 8.49982 12 6 12C3.50018 12 2.25027 12 1.37405 11.3634C1.09107 11.1578 0.842209 10.9089 0.63661 10.626C0 9.74973 0 8.49982 0 6ZM6 2.16667C6.27614 2.16667 6.5 2.39052 6.5 2.66667V6.66667C6.5 6.94281 6.27614 7.16667 6 7.16667C5.72386 7.16667 5.5 6.94281 5.5 6.66667V2.66667C5.5 2.39052 5.72386 2.16667 6 2.16667ZM6 9.33333C6.36819 9.33333 6.66667 9.03486 6.66667 8.66667C6.66667 8.29848 6.36819 8 6 8C5.63181 8 5.33333 8.29848 5.33333 8.66667C5.33333 9.03486 5.63181 9.33333 6 9.33333Z",
    fill: "#F35B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.17b39ddac30d25900ee246f37e4cf500.svg";
export { ForwardRef as ReactComponent };